import { BaseNotificacionesService } from "../base/baseApiNotificaciones";

export class NotificacionesService extends BaseNotificacionesService {
  async enviarNotificacion(payloadNotificacion: any) {
    try {
      const { data } = await this.axiosClient.post(`/notificaciones`, payloadNotificacion);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarDocumento with stack: ${error}`);
    }
  }

  async enviarNotificacionAdministrador(payloadNotificacion: any) {
    try {
      const { data } = await this.axiosClient.post(`/notificaciones/administrativas`, payloadNotificacion);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarDocumento with stack: ${error}`);
    }
  }


  async notificacionsRecibidas(documentoUsuario: number) {
    try {
      const { data } = await this.axiosClient.get(`/notificaciones/notificacionsRecibidas/${documentoUsuario}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in notificacionsRecibidas with stack: ${error}`);
    }
  }

  async notificacionesVistas(documentoUsuario: number) {
    try {
      const { data } = await this.axiosClient.post(`/notificaciones/actualizar-notificacion`, {
        documento: documentoUsuario
      });
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in notificacionsRecibidas with stack: ${error}`);
    }
  }

  
}

export default new NotificacionesService();